/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessResponse as ModelsSuccessResponse } from '../../models/models/success-response';

export interface ApiV1Auth2FaTotpSetupStartPost$Params {
}

export function apiV1Auth2FaTotpSetupStartPost(http: HttpClient, rootUrl: string, params?: ApiV1Auth2FaTotpSetupStartPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1Auth2FaTotpSetupStartPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSuccessResponse>;
    })
  );
}

apiV1Auth2FaTotpSetupStartPost.PATH = '/api/v1/auth/2fa/totp/setup/start';
